<template>
  <div class="expert_sapce">
    <h1>{{homeExports}}</h1>
    <div class="imgUnion">
      <el-row :gutter="30">
        <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">
          <div class="h_expert_arrow">
            <div class="el-icon-arrow-left h_arrow_item" @click="goAuthor(2)"></div>
          </div>
        </el-col>
        <el-col :xs="11" :sm="11" :md="5" :lg="5" :xl="4" v-for="(itemA,index) in swiperList" :key="index">
          <el-card class="box-card define_card">
            <img :src="itemA.path" alt="" width="100%" height="255">
            <p>{{itemA.title}}</p>
          </el-card>
        </el-col>
        <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">
          <div class="h_expert_arrow">
            <div class="el-icon-arrow-right h_arrow_item" @click="goAuthor(1)"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { homeExpert } from '@/api/frontApi/frontHome';
import { backLoop, forwardLoop } from '@/common/util/pictureLoop';
export default {
  data() {
    return {
      swiperList: [], // 展示区域容器
      swiperCup: [], // 所有专家照片容器
      homeExports: '国家农机装备创新中心专家委员会成员',
      screenWidth: 0
    };
  },
  created() {
    this.authorityList();
  },
  mounted() {
    const that = this;
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        that.screenWidth = document.body.clientWidth;
      })();
    };
  },
  watch: {
    screenWidth(swVal) {
      if (swVal >= 1500) {
        this.swiperList = this.swiperCup.slice(0, 5);
      } else if (swVal < 1500 && swVal > 1000) {
        this.swiperList = this.swiperCup.slice(0, 4);
      } else if (swVal < 1000 && swVal > 768) {
        this.swiperList = this.swiperCup.slice(0, 3);
      } else if (swVal < 768) {
        this.swiperList = this.swiperCup.slice(0, 2);
      }
    }
  },
  methods: {
    authorityList() {
      this.swiperList = [];
      homeExpert({ pageNo: 1, pageSize: 500 }).then(res => {
        let expertArr = res.data.list;
        for (let i = 0; i < expertArr.length; i++) {
          let tempObj = { path: '', title: '', eid: '' };
          tempObj.path = expertArr[i].expertImg;
          tempObj.title = expertArr[i].expertName + expertArr[i].expertHonor;
          tempObj.eid = expertArr[i].expertId;
          this.swiperCup.push(tempObj);
        }
        this.swiperList = this.swiperCup.slice(0, 5);
      });
    },
    goAuthor(type) {
      switch (type) {
        case 1:
          this.swiperList = forwardLoop(this.swiperList, this.swiperCup, 'eid');
          break;
        case 2:
          this.swiperList = backLoop(this.swiperList, this.swiperCup, 'eid');
          break;
      }
    }
  }
};
</script>
<style scoped>
.expert_sapce {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.imgUnion {
  width: 90%;
  margin: 1% auto 0;
}
.imgCup {
  cursor: pointer;
  width: 90%;
  padding-bottom: 10px;
  margin-bottom: 20px;
}
.h_expert_arrow {
  width: 100%;
  height: 345px;
  text-align: center;
}
.h_arrow_item:hover {
  cursor: pointer;
}
.h_arrow_item {
  font-size: 54px;
  width: 60px;
  height: 60px;
  line-height: 60px;
  margin-top: 128px;
}
.define_card {
  max-height: 345px;
}

.box-card:hover {
  box-shadow: 10px 10px 5px #888888;
}
.author-Arrow {
  margin-top: 9.5%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeExpert.vue